export const previously = [
  "I have prior experience of project planning, costing, forecasting and risk assessments. I am proficient with maintenance management and risk based inspection systems.",
  "If you're looking for a developer with project management experience, I may be a great fit for your team."
]